import React, { useEffect, useState } from "react";
import firebase from "./firebase";
import List from "./List";
import { CurrentPosition, Store } from "./types";
import { useAuthState } from "react-firebase-hooks/auth";
import { useLocation } from "wouter";

export default function ListMine(props: CurrentPosition) {
  const [tileData, setTileData] = useState<Store[]>([]);
  const [, setLocation] = useLocation();
  const [user, loading] = useAuthState(firebase.auth());
  const [fetching, setFetching] = useState(true);
  useEffect(() => {
    if (user) {
      const db = firebase.firestore();
      let list: Store[] = [];
      db.collection("store")
        .where("uid", "==", user.uid)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            list.push({
              ...doc.data(),
              createdTime: doc.data().createdTime.toDate(),
            } as Store);
          });
          setTileData(list);
          setFetching(false);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    } else if (!loading) {
      setFetching(false);
    }
  }, [user, loading]);

  if (loading || fetching) {
    return <div />;
  }
  if (!user) {
    setLocation("/login");
  }

  return <List position={props} tileData={tileData} deletable></List>;
}
